export default __webpack_public_path__ + "static/media/klaus_l.1913badd.jpg";